import React from 'react';
import Footer from '../../components/Footer/Footer';
import NavBar from '../../components/NavBar/NavBar';

const PrivacyPolicy: React.FC = () => {
    return (
        <>
            <NavBar />
            <div className='main_content'>
                <h2>PRIVACY POLICY</h2>
                <div className='container_informations_page'>
                    <p><strong>Effective Date:</strong> 2023-05-23</p>
                    <p>This Privacy Policy outlines how <strong>magicbot.fr</strong> and its subdomains ("we," "us," or "our") collect, use, and protect the personal information of users ("you" or "your") who visit our website and use our contact form. By accessing and using our website, you consent to the practices described in this Privacy Policy.</p>
                    <h3>1. Information We Collect</h3>
                    <p>We collect the following personal information when you fill out our contact form:</p>
                    <ul>
                        <li>Name</li>
                        <li>Email address</li>
                    </ul>
                    <h3>2. Collection Methods</h3>
                    <p>Personal information is collected via the contact form when you send us a message. We do not collect any other information other than what you voluntarily provide via this form.</p>
                    <h3>3. Use of Information</h3>
                    <p>The information we collect is used solely for the purpose of responding to your message. We do not use it for any other purpose.</p>
                    <h3>4. Data Sharing</h3>
                    <p>We do not share your personal information with any third parties. It is used solely for the purpose of managing your inquiries via our contact form.</p>
                    <h3>5. Cookies and Tracking Technologies</h3>
                    <p>We do not use cookies on our website.</p>
                    <h3>6. Data Security</h3>
                    <p>We take the security of your personal information very seriously. All personal user information is securely stored and protected against unauthorized access.</p>
                    <h3>7. User Rights</h3>
                    <p>Under the General Data Protection Regulation (GDPR), you have the following rights regarding your personal information:</p>
                    <ul>
                        <li>Right of Access</li>
                        <li>Right to Rectification</li>
                        <li>Right to Erasure</li>
                        <li>Right to Restrict Processing</li>
                        <li>Right to Object</li>
                        <li>Right to Data Portability</li>
                    </ul>
                    <p>To exercise any of these rights, please contact us at <a href="mailto:dpo@magicbot.fr" >dpo@magicbot.fr</a>. We will promptly respond to your requests in accordance with applicable data protection laws.</p>
                    <h3>8. Data Retention</h3>
                    <p>We retain your personal information for a period necessary to manage your inquiry via the contact form, after which it will be deleted once the request is processed.</p>
                    <h3>9. Lawful Data Transfers</h3>
                    <p>We do not transfer your personal data outside of the European Union (EU).</p>
                    <h3>10. Profiling and Automated Decision-Making</h3>
                    <p>We do not engage in profiling or automated decision-making using your personal information.</p>
                    <h3>11. Data Protection Officer (DPO)</h3>
                    <p>Our Data Protection Officer (DPO) can be contacted via email at <a href="mailto:dpo@magicbot.fr">dpo@magicbot.fr</a> for any questions or concerns regarding the processing of your personal information.</p>
                    <h3>12. Complaints</h3>
                    <p>If you believe that we have not adequately addressed your privacy concerns, you have the right to lodge a complaint with the competent supervisory authority. Please contact your local data protection authority for more information.</p>
                    <h3>13. Policy Updates</h3>
                    <p>We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. Any updates will be effective upon posting the revised Privacy Policy on our website. We recommend reviewing this Privacy Policy regularly for any changes.</p>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default PrivacyPolicy;
